import React from 'react';
import Icon from '../../../components/AppIcon';

const InvoiceStats = ({ 
  stats = {},
  className = ''
}) => {
  const {
    total = 0,
    reviewed = 0,
    needsReview = 0,
    exported = 0,
    totalValue = 0,
    avgConfidence = 0,
    currency = 'GBP'
  } = stats;

  const formatCurrency = (amount) => {
    const symbol = currency === 'EUR' ? '€' : '£';
    return `${symbol}${amount?.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const getPercentage = (value, total) => {
    if (total === 0) return 0;
    return Math.round((value / total) * 100);
  };

  const statCards = [
    {
      label: 'Total Invoices',
      value: total?.toLocaleString(),
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Reviewed',
      value: reviewed?.toLocaleString(),
      subtitle: `${getPercentage(reviewed, total)}% of total`,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Needs Review',
      value: needsReview?.toLocaleString(),
      subtitle: `${getPercentage(needsReview, total)}% of total`,
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Exported',
      value: exported?.toLocaleString(),
      subtitle: `${getPercentage(exported, total)}% of total`,
      icon: 'Download',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Total Value',
      value: formatCurrency(totalValue),
      icon: 'PoundSterling',
      color: 'text-foreground',
      bgColor: 'bg-muted'
    },
    {
      label: 'Avg Confidence',
      value: `${Math.round(avgConfidence * 100)}%`,
      subtitle: avgConfidence >= 0.8 ? 'Excellent' : avgConfidence >= 0.6 ? 'Good' : 'Needs attention',
      icon: 'TrendingUp',
      color: avgConfidence >= 0.8 ? 'text-success' : avgConfidence >= 0.6 ? 'text-warning' : 'text-error',
      bgColor: avgConfidence >= 0.8 ? 'bg-success/10' : avgConfidence >= 0.6 ? 'bg-warning/10' : 'bg-error/10'
    }
  ];

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 ${className}`}>
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-subtle transition-smooth"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
          </div>
          
          <div className="space-y-1">
            <div className={`text-2xl font-bold ${stat?.color}`}>
              {stat?.value}
            </div>
            <div className="text-sm font-medium text-foreground">
              {stat?.label}
            </div>
            {stat?.subtitle && (
              <div className="text-xs text-muted-foreground">
                {stat?.subtitle}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceStats;